import { parse as parseflatted } from 'flatted';
import FlattedText from '../../flatted-text/FlattedText';
import IconTitleItem from '../../IconTitleItem/IconTitleItem';
import {
  ANCHAIN_POSSIBLE_KEYS,
  getAnchainFieldIcon,
  getAnchainFieldTitle,
  parseAnchainResponse,
} from './helper/anchain.parser';

interface Props {
  data: any;
}

const buildParsedData = (data: any) => {
  return Object.keys(data).map((key) => {
    if (key === ANCHAIN_POSSIBLE_KEYS.REASON) {
      return (
        <IconTitleItem
          icon={getAnchainFieldIcon(ANCHAIN_POSSIBLE_KEYS.REASON)}
          title={getAnchainFieldTitle(ANCHAIN_POSSIBLE_KEYS.REASON)}
          subTitle={data.reason}
          className='col-span-3'
        />
      );
    } else {
      return (
        <IconTitleItem
          icon={getAnchainFieldIcon(key)}
          title={getAnchainFieldTitle(key)}
          subTitle={data[key]}
        />
      );
    }
  });
};

const AnchainResponse = ({ data }: Props) => {
  const dataObj = parseflatted(data);

  const parsedData = parseAnchainResponse(dataObj);

  if (typeof parsedData == 'object' && Object.keys(parsedData).length > 0) {
    return (
      <div className='grid gap-3 grid-cols-3'>
        {buildParsedData(parsedData)}
      </div>
    );
  }

  return <FlattedText flattedText={data} />;
};

export default AnchainResponse;
